import { Phone, WhatsappLogo, PaperPlaneTilt } from '@phosphor-icons/react';
import { useLocation } from 'react-router-dom';
import { buildWAUrl, getPageMessage, TEL } from '../lib/whatsapp';

interface Props {
  onGetQuote: () => void;
}

export default function MobileBottomBar({ onGetQuote }: Props) {
  const { pathname } = useLocation();
  const waUrl = buildWAUrl(getPageMessage(pathname));

  return (
    // md:hidden - only visible on mobile/tablet
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-[80] bg-white border-t border-gray-100 shadow-[0_-4px_20px_rgba(0,0,0,0.07)] flex">
      <a
        href={TEL}
        className="flex-1 flex flex-col items-center justify-center py-3 gap-0.5 text-[#071126] hover:bg-gray-50 active:bg-gray-100 transition-colors"
      >
        <Phone size={19} weight="fill" />
        <span className="text-[9px] font-black uppercase tracking-wider mt-0.5">Call</span>
      </a>

      <a
        href={waUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="flex-1 flex flex-col items-center justify-center py-3 gap-0.5 bg-[#0F7A35] text-white hover:bg-[#20ba5a] active:bg-[#1da856] transition-colors"
      >
        <WhatsappLogo size={19} weight="fill" />
        <span className="text-[9px] font-black uppercase tracking-wider mt-0.5">WhatsApp</span>
      </a>

      <button
        onClick={onGetQuote}
        className="flex-1 flex flex-col items-center justify-center py-3 gap-0.5 bg-[#0077CC] text-white hover:bg-[#071126] active:bg-[#091729] transition-colors"
      >
        <PaperPlaneTilt size={19} weight="fill" />
        <span className="text-[9px] font-black uppercase tracking-wider mt-0.5">Get Quote</span>
      </button>
    </div>
  );
}
